import { useTranslation } from "react-i18next"
import { CategoryEntity } from "../../Objects/Category/CategoryEntity"
import { categoryMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetCategory = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetCategory = async (onSuccess: any, rote: string = API_ROUTES.CATEGORY.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<CategoryEntity[]>(rote)

      if (response.success) {
        const temp = response.data?.map((ss) => new CategoryEntity(ss)) ?? []

        categoryMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetCategory,
  }
}
